import type { MapEvidenceTopic } from "../../enums/map";

/**
 * How each evidence topic reads on screen. Surface copy for the map, keyed by
 * the topic so a new topic fails to compile until it is worded.
 */
const MAP_EVIDENCE_LABELS: Record<MapEvidenceTopic, string> = {
  sibling_url_structure: "Sibling URL structure",
  no_organising_page: "No organising page recorded",
  material_overlap: "Material overlap signal",
  shared_page_role: "Shared page role",
  mixed_structural_roles: "Mixed structural roles",
  client_context_required: "Client context required",
  onward_relationship: "Recorded onward relationship",
  path_break: "Potential path break",
  assessment_coverage: "Assessment coverage",
  shared_page_pattern: "Shared page pattern",
  // Issue evidence carries the issue's own title as its heading, so this is
  // only the fallback when one is missing.
  issue_finding: "Linked finding",
};

/**
 * The heading shown above a piece of evidence: the producer's own heading when
 * it has one (an issue's title), otherwise the topic's standard wording.
 */
export function mapEvidenceLabel(evidence: {
  topic: MapEvidenceTopic;
  heading?: string;
}): string {
  return evidence.heading ?? MAP_EVIDENCE_LABELS[evidence.topic];
}
